import React, {useCallback} from "react";
import Form from "react-bootstrap/Form";
import {MODE_CREATE, MODE_EDIT} from "../../../codes";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Editor from "../../../common/Editor";
import useBudgetCategoryEditor, {TYPE_EXPENSE, TYPE_INCOME} from "./useBudgetCategoryEditor";
import InputGroup from "react-bootstrap/InputGroup";
import {DeleteModal} from "../../../common/AppModal";
import useProject from "../../../util/useProject";
import {CategoriesDropdown} from "../../../common/CategoriesDropdown";
import {RadioField} from "../../../common/RadioField";

export const BudgetCategoryEditor = () => {
  const {
    show,
    t,
    mode,
    submit,
    hideBudgetCategoryEditor,
    editedCategory,
    availableCategories,
    updateEditedCategory,
    deleteConfirmationModal,
    showDeleteConfirmationModal,
    hideDeleteConfirmationModal,
    onDeleteBudgetCategory
  } = useBudgetCategoryEditor();

  const {runWithExpiration} = useProject();

  const typeChoices = [
    {value: TYPE_EXPENSE, label: t("budget_category_editor_type_expense"), activeClass: "danger"},
    {value: TYPE_INCOME, label: t("budget_category_editor_type_income"), activeClass: "success"}
  ];

  return <Editor
    show={show}
    title={t(mode === MODE_CREATE ? "budget_category_editor_title_add" : "budget_category_editor_title_edit")}
    onShow={useCallback(() => document.getElementById("budget-category-editor-amount").focus(), [])}
    onSubmit={runWithExpiration(submit)}
    onCancel={hideBudgetCategoryEditor}
    onDelete={mode === MODE_EDIT ? runWithExpiration(showDeleteConfirmationModal) : null}
    submitLabel={t("budget_category_editor_button_save")}
    cancelLabel={t("budget_category_editor_button_cancel")}
  >
    <Form.Group as={Row} className="mb-2" controlId="budget-category-editor-category">
      <Form.Label column sm={3}>{t("budget_category_editor_field_category")}</Form.Label>
      <Col sm={9}>
        {mode === MODE_CREATE && <CategoriesDropdown
          categories={availableCategories}
          value={editedCategory.category}
          onChange={updateEditedCategory("category")}
          allowNoCategory={false}
        />}

        {mode === MODE_EDIT && <Form.Control
          type="text"
          disabled
          value={(availableCategories.find(c => c.id === editedCategory.category) || {name: ""}).name}
        />}
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2">
      <Form.Label column sm={3}>{t("budget_category_editor_field_type")}</Form.Label>
      <Col sm={9}>
        <RadioField
          value={editedCategory.type}
          choices={typeChoices}
          onChange={updateEditedCategory("type")}
        />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="budget-category-editor-amount">
      <Form.Label column sm={3}>{t("budget_category_editor_field_amount")}</Form.Label>
      <Col sm={9}>
        <InputGroup hasValidation>
          <Form.Control
            type="text"
            value={editedCategory.amount}
            onChange={updateEditedCategory("amount")}
            isInvalid={editedCategory.errors.amount}
          />
          <Form.Control.Feedback type="invalid">{t(editedCategory.errors.amount)}</Form.Control.Feedback>
        </InputGroup>
      </Col>
    </Form.Group>

    <DeleteModal
      show={deleteConfirmationModal}
      title={t("modal_delete_title")}
      cancelLabel={t("modal_delete_button_cancel")}
      submitLabel={t("modal_delete_button_apply")}
      onCancel={hideDeleteConfirmationModal}
      onSubmit={onDeleteBudgetCategory}
    >
      {t("modal_delete_body")}
    </DeleteModal>
  </Editor>;
};
